import { Dispatch, ActionCreator } from "redux";
import { ThunkAction } from "redux-thunk";

import { AppConfigsActionDispatchTypes, GetConfigVariablesActionDispatchTypes } from "../constants/AppConfigs";
import { AppConfigsDispatchTypes, GetConfigVariablesDispatchTypes } from "../models/DispatchTypes/AppConfigs";
import { GetAppConfigs } from "../services/AppConfigs";
import { ApplicationState } from "../store/ApplicationState";
import { GetConfigVariables } from "services/User";
import { configs, configUrlForReferral } from "constants/Config";
import SnackbarUtils from "../utils/SnackbarProvider";
import { MessageType, ResponseMessages } from "constants/ToastMessage";

export const getConfigs: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    AppConfigsDispatchTypes
  >
> = (configFileName: string) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: AppConfigsActionDispatchTypes.APP_CONFIG_INVOKE,
    });
    const response = await GetAppConfigs(configFileName);
    dispatch({
      response: response,
      type: AppConfigsActionDispatchTypes.APP_CONFIG_SUCCESS,
    });
  };
};

export const getConfigVariables: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    GetConfigVariablesDispatchTypes
  >
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: GetConfigVariablesActionDispatchTypes.GET_CONFIG_INVOKE,
    });
    const response = await GetConfigVariables(configUrlForReferral);
    if (response && response.status) {
          switch (response.status) {
            case 422:
            case 400:
            case 404:
            case 500:
              SnackbarUtils.error(ResponseMessages(MessageType.CONFIG_VARIABLES_ERROR));
              dispatch({
                error: response,
                type: GetConfigVariablesActionDispatchTypes.GET_CONFIG_ERROR,
              });
              break;
            case 200:
            case 201:
              dispatch({
                response: {
                  ...configs,
                  ...response.data,
                },
                type: GetConfigVariablesActionDispatchTypes.GET_CONFIG_SUCCESS,
              });
              break;
            default:
              break;
          }
        }
  };
};
